import { atom } from "recoil";

type TaskId = string;

export const asyncJobTaskState = atom<TaskId | undefined>({
  key: "exportCSVState",
  default: undefined,
});

export const asyncJobMenuState = atom<"collapsed" | "expanded" | "closed">({
  key: "asyncJobMenuState",
  default: "closed",
});
